import React from 'react';
import PropTypes from 'prop-types';
import './ReSign.scss';
import ReSignContact from './ReSignContact';

const ReSignError = (props) => {
  const { status } = props.error;
  return (
    <div>
      {status.code === 204 ?
        <div>
          <h2>Whoops, something went wrong...</h2>
          <div>
            It looks like the link you&apos;re using isn&apos;t working properly!
            If you copied the link from your email, double-check that you&apos;ve copied the entire link.
          </div>
          <div>
            If you need to get in contact us with us, you can do so via one of the options below:
          </div>
          <ReSignContact />
        </div>
        : <div className="resign-error-container">
          <h2>Whoops, something went wrong, please try again later.</h2>
          <div id="re-sign-error" className="error-message">
            Error Message: {status.text}
          </div>
        </div>
      }
    </div>
  );
};

ReSignError.propTypes = {
  error: PropTypes.object.isRequired
};

export default ReSignError;



/** WEBPACK FOOTER **
 ** ./src/components/ReSign/ReSignError.js
 **/